// extracted by mini-css-extract-plugin
module.exports = {"completedToast":"CompletedToast_completedToast__UlWxc"};